let isDown = false;
let startX;
let scrollLeft;
let itemsScrollPosition;
let firstDatePosition;
let lastDatePosition;

$(document).ready(() => {
    $('.calendar-page-result input').change((e) => filter(e));
    $('.calendar-page-result .load-more-button').click((e) => loadMore(e));
    $('.calendar-page-result .reset-calendar-button').click((e) => resetDate(e));
    $('.calendar-page-result .month-select-item span').click((e) => filterDate(e));
    setInitialScrollPosition()
    $('.calendar-page-result .items').scrollLeft(itemsScrollPosition);
});

function loadMore(e) {
    var form = $(e.target).closest('.calendar-page-form')[0]
    var input = $(form).children('.take-input')[0];
    $(input).val(parseInt($(input).val()) + 6);
    submitForm(e);
}

function resetDate(e) {
    var form = $(e.target).closest('.calendar-page-form')[0]
    var input = $(form).children('.reset-input')[0];
    $(input).val(true);
    setInitialScrollPosition();
    submitForm(e);
}

function setInitialScrollPosition() {
    if ($(".calendar-page-result .items").length > 0) {
        itemsScrollPosition = ($('.items').get(0).scrollWidth / 2 - $('.items').width() / 3);
    }
}

function filter(e) {
    var form = $(e.target).closest('.calendar-page-form')[0];
    var id = e.target.id;
    var type = id.substr(0, id.indexOf('_'));
    var all = document.getElementById(type + '_0__Selected');

    if (type == "EventResponsibles") {
        var elems = $(form).find('input:checkbox[id^=' + type + "]");
        elems.each((i, e) => {
            if (id != e.id) {
                e.value = false
                e.checked = null
            }
        });
    }
    else {
        if (!id.includes('0__Selected') && e.target.checked) {
            all.value = false;
            all.checked = null;
        }
        else if (id.includes('0__Selected')) {
            var elems = $('input:checkbox[id^=' + type + "]");
            elems.each((i, e) => {
                e.value = false
                e.checked = null
            });
        }
    }

    submitForm(e);
}

function submitForm(e) {
    setFilterDates(e)
    var form = $(e.target).closest('.calendar-page-form')[0];
    var valdata = $(form).serialize();
    $.ajax({
        url: $(form).attr('action'),
        type: 'Get',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: valdata,
        success: function (data) {
            var html = $(form).closest('.calendar-page-result')[0];
            $(html).replaceWith(data);
            $('.calendar-page-result input').change((e) => filter(e));
            $('.calendar-page-result .load-more-button').click((e) => loadMore(e));
            $('.calendar-page-result .reset-calendar-button').click((e) => resetDate(e));
            $('.calendar-page-result .month-select-item span').click((e) => filterDate(e));
            $('.calendar-page-result .items').scrollLeft(itemsScrollPosition);
        }
    });
}

function filterDate(e) {
    var parent = e.target.parentElement;
    var form = $(e.target).closest('.calendar-page-form')[0];
    scrollLeft = $(form).find('.items').scrollLeft();
    itemsScrollPosition = scrollLeft;

    if ($(form).find('.month-select-item.selected').length == 1) {
        if ($(parent).hasClass('selected')) return;
    }
    else {
        $(form).find('.month-select-item.selected').removeClass('selected');
        $(form).find('.item-between-selected').removeClass('item-between-selected');
        $(form).find('.no-item-between-selected').removeClass('no-item-between-selected');
    }

    $(parent).toggleClass('selected');

    submitForm(e);
}

function setFilterDates(e) {
    var form = $(e.target).closest('.calendar-page-form')[0];
    var firstSelectedId = $(form).find('.month-select-item.selected').first().attr("id");
    var lastSelectedId = $(form).find('.month-select-item.selected').last().attr("id");
    $(form).children('#FilterStartDate').val(firstSelectedId);
    $(form).children('#FilterEndDate').val(lastSelectedId);
}

$(document).on('mousedown', '.calendar-page-result .items', function (e) {
    isDown = true;
    $('.items').addClass('active');
    startX = e.pageX - document.querySelector('.items').offsetLeft;
    scrollLeft = $('.items').scrollLeft();
});

$(document).on('mouseleave', '.calendar-page-result .items', function (e) {
    isDown = false;
    $('.items').removeClass('active');
});

$(document).on('mouseup', '.calendar-page-result .items', function (e) {
    isDown = false;
    $('.items').removeClass('active');
});

$(document).on('mousemove', '.calendar-page-result .items', function (e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - document.querySelector('.items').offsetLeft;
    const walk = (x - startX) * 1;
    itemsScrollPosition = scrollLeft - walk
    $('.items').scrollLeft(itemsScrollPosition);
});